
import { useState, useCallback } from 'react';
import { EnhancedCrawlResult } from '@/types/crawler';

export function useCrawlerState() {
  const [isAnalyzing, setIsAnalyzing] = useState<boolean>(false);
  const [crawlResult, setCrawlResult] = useState<EnhancedCrawlResult | null>(null);
  const [websiteUrl, setWebsiteUrl] = useState<string>('');
  const [sitemapStats, setSitemapStats] = useState<any>(null);

  // Function to clear crawl results (no storage involved)
  const clearCrawlResults = useCallback(() => {
    console.log('Clearing crawl results');
    setCrawlResult(null);
    setWebsiteUrl('');
    setSitemapStats(null);
  }, []);

  return {
    isAnalyzing,
    setIsAnalyzing,
    crawlResult,
    setCrawlResult,
    websiteUrl,
    setWebsiteUrl,
    sitemapStats,
    setSitemapStats,
    clearCrawlResults
  };
}
